'use strict';

(function(){

    /*
        Angular-agnostic classes to be used as prototypes.
     */

    if (!window.jim) window.jim = {};

    jim.Subscription = function(properties){

        var self = this;

        var PAYMENT_TYPE = {
            PREPAID: 'PREPAID',
            POSTPAID: 'POSTPAID'
        };

        self.isPrepaid = function(){
            return this.type === PAYMENT_TYPE.PREPAID;
        };

        self.isPostpaid = function(){
            return this.type === PAYMENT_TYPE.POSTPAID;
        };

        self.isCancelled = function(){
            return !!this.validUntil;
        };

        self.isDisabled = function(){
            return this.state === 'disabled';
        };

        for (var prop in properties){
            if (properties.hasOwnProperty(prop))
                self[prop] = properties[prop];

            if (this.validUntil && !this.validUntil.isValid())
                this.validUntil = undefined;
        }
    };

    jim.Subscription.fromObject = function(properties){
        if (!properties){
            return null;
        }
        else {
            return new jim.Subscription(properties);
        }
    };

    /**
     * A 'subscriber'.  This is essentially a set of subscriptions that belongs to the same msisdn.
     * For the moment we only support one msisdn, but this is bound to change.  SBSS will also start
     * supporting an identifier for this concept, at which point we'll stop using msisdn for it.
     * */
    jim.Subscriber = function(subscription){
        var self = this;
        var msisdn = subscription.msisdn;
        self.msisdn = msisdn;
        self.subscription = subscription;

        self.isPrepaid = function(){
            return subscription.isPrepaid();
        };

        self.isPostpaid = function(){
            return subscription.isPostpaid();
        };

        self.isCancelled = function(){
            return subscription.isCancelled();
        };

        Object.defineProperty(self, 'active', {get: function(){ return subscription; }});

        /** Returns the ID of the 'active' subscription.  This prop only exists for backwards compatibility with
         *  the legacy subscription object. */
        Object.defineProperty(self, 'id', {get: function(){ return subscription.id; }});

        Object.defineProperty(self, 'product', {get: function(){
            return subscription.product;
        }});

        Object.defineProperty(self, 'validUntil', {get: function(){
            return subscription.validUntil;
        }});

        Object.defineProperty(self, 'validFrom', {get: function(){
            return subscription.validFrom;
        }});

        Object.defineProperty(self, 'order', {get: function(){
            return subscription.order;
        }});

        Object.defineProperty(self, 'label', {get: function(){
            if (subscription.alias) return subscription.msisdn + ' ('+subscription.alias+')';
            else return subscription.msisdn;
        }});

        Object.defineProperty(self, 'alias', {get: function(){
            return subscription.alias;
        }});

        /**
         * The new product in case of a migration subscriber.
         */
        Object.defineProperty(self, 'newProduct', {get: function(){
            return subscription.pendingProduct ? subscription.pendingProduct.product : undefined;
        }});

        Object.defineProperty(self, 'oldProduct', {get: function(){
            return undefined;
        }});

        Object.defineProperty(self, 'oldProductEndDate', {get: function(){
            return undefined;
        }});

        Object.defineProperty(self, 'state', {get: function(){
            if (subscription.pendingProduct) return jim.SubscriberState.migrating;
            if (subscription.state === jim.SubscriptionState.disabled && subscription.order)
                return jim.SubscriberState.pending;
            if (subscription.isCancelled()) return jim.SubscriberState.cancelled;
            return subscription.state;
        }});

        Object.defineProperty(self, 'sim', {get: function(){
            return subscription.sim;
        }});

    };


    jim.Subscriber.fromSubscriptions = function(subscriptions){
        return subscriptions.map(function(s){ return new jim.Subscriber(s); });
    };

    jim.Product = function(properties){

        var self = this;

        self.typeIs = function(type){
            return self.type && self.type.match(new RegExp('^' + type + '(/|$)')) !== null;
        };

        self.hasOrderParameter = function(parameter){
            return self.orderParameters && Object.keys(self.orderParameters).indexOf(parameter)>=0;
        };

        /**
         * @return the parameter used for shipmentAddress, if any
         */
        self.getShipmentAddressParameter = function(){
            if (!self.orderParameters) return undefined;
            for (var param in self.orderParameters){
                if (self.orderParameters[param] === 'shipping_address')
                    return param;
            }
            return undefined;
        };

        self.allowsMnp = function(){
            return self.typeIs('prepaid') || self.typeIs('postpaid');
        };

        self.allowsPreexistingSim = function(){
            return self.hasOrderParameter('iccid');
        };

        self.requiresPaymentConfig = function(){
            return self.typeIs('postpaid');
        };

        self.requiresRegistration = function(){
            return self.typeIs('prepaid');
        };

        self.requiresTopupToSend = function(){
            return self.typeIs('prepaid');
        };

        self.allowsVat = function(){
            return self.isPostpaid();
        };

        self.canBePaidImmediately = function(){
            if (!self.paymentProviders) return true;
            return self.paymentProviders.indexOf('mollie') >= 0;
        };

        self.isPostpaid = function () {
            return self.typeIs('postpaid');
        };

        self.isPrepaid = function () {
            return self.typeIs('prepaid');
        };

        for (var prop in properties){
            if (properties.hasOwnProperty(prop))
                self[prop] = properties[prop];
        }
    };

    jim.Product.fromProperties = function(properties){
        if (!properties) return null;
        return new jim.Product(properties);
    };

    jim.ProductType = {
        'prepaid_subscription': 'prepaid',
        'postpaid_subscription': 'postpaid',
        'topup': 'prepaid/topup'
    };

    jim.OrderState = {
        'waiting_for_port_in': 'waiting_for_port_in',
        'waiting_for_sim': 'waiting_for_sim',
        'waiting_for_sim_activation_request': 'waiting_for_sim_activation_request',
        'waiting_for_sim_matching': 'waiting_for_sim_matching',
        'waiting_for_payment': 'waiting_for_payment',
        'waiting_for_customer_verification': 'waiting_for_customer_verification',
        'waiting_for_switch_accept': 'waiting_for_switch_accept',
        'waiting_for_internal_processing': 'waiting_for_internal_processing',
        'created': 'created',
        'processing': 'processing',
        'review_needed': 'review_needed',
        'cancelled': 'cancelled',
        'failed': 'failed',
        'enabled': 'enabled',
        'unknown': 'unknown',
        'mnp_rejected': 'mnp_rejected'
    };

    jim.InvoiceState = {
        'accepted': 'accepted',
        'bad_dept': 'bad_dept',
        'cancelled': 'cancelled',
        'created': 'created',
        'issued': 'issued',
        'paid': 'paid',
        'partially_paid': 'partially_paid',
        'pending_payment': 'pending_payment',
        'review': 'review'
    };

    jim.SubscriptionState = {
        'disabled': 'disabled',
        'enabled': 'enabled',
        'deleted': 'deleted',
        'locked': 'locked',
        'unknown': 'unknown',
        'pending': 'pending' // state to indicate the subscription is still being created
    };

    jim.SubscriberState = {
        'disabled': 'disabled',
        'enabled': 'enabled',
        'deleted': 'deleted',
        'locked': 'locked',
        'unknown': 'unknown',
        'cancelled': 'cancelled',
        'migrating': 'migrating',
        'pending': 'pending' // state to indicate the subscription is still being created
    };

    jim.OrderType = {
        ORDER_A_SIM: 'order_a_sim',
        ORDER_A_TOPUP: 'order_a_topup',
        ORDER_A_PACKAGE: 'order_a_package',
        ORDER_A_MIGRATION: 'order_a_migration',
        ORDER_A_LIGHT_TO_FULL_MIGRATION: 'light_to_full_migration',
        ORDER_A_SWAP: 'swap_sim',
        SILENT_IMSI_SWAP: 'silent_imsi_sim_swap',
        TERMINATE_CONTRACT: 'terminate_contract',
        SIM_ACTIVATION: 'activation_sim',
        UNKNOWN_ORDER: 'unknown'
    };

    jim.DonorType = {
        PREPAID: 'prepaid',
        PRIVATE_POSTPAID: 'private_postpaid',
        BUSINESS_POSTPAID: 'business_postpaid'
    };

    jim.values = function(enumType){
        var result = Object.keys(enumType).map(function(key){ return enumType[key]; });
        result.except = function(){
            var toRemove = [].map.call(arguments, function(i){ return i; });
            return result.filter(function(v){ return !toRemove.includes(v); });
        };
        return result;
    };

}());
